import React, { useState, useEffect } from 'react';
import { onMessageListener } from '../firebase';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const CreditNotification = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState({ title: '', body: '' });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    // Handle foreground messages
    onMessageListener().then((payload) => {
      setMessage({
        title: payload.notification.title,
        body: payload.notification.body
      });
      setOpen(true);
    });
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        onClose={handleClose}
        severity="warning"
        variant="filled"
        sx={{ width: '100%' }}
      >
        <AlertTitle>{message.title}</AlertTitle>
        {message.body}
      </Alert>
    </Snackbar>
  );
};

export default CreditNotification;